import React from 'react';
import classnames from 'classnames';

import { Grid, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Image, Translate } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(2)
  },
  title: {
    fontSize: 22,
    fontWeight: theme.typography.fontWeightSemibold,
    marginTop: theme.spacing(2)
  },
  subtitle: {
    fontSize: theme.typography.fontSizeRoot
  },
  btn: {
    fontSize: theme.typography.fontSizeLarge,
    fontWeight: theme.typography.fontWeightSemibold,
    marginTop: theme.spacing(2),
    paddingLeft: 0,
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline'
    }
  },
  img: {
    display: 'block',
    objectFit: 'cover',
    width: '100%',
    borderRadius: theme.shape.borderRadius * 2.5
  }
}));

export interface ArticleCardProps {
  img: string
  title: string
  subtitle: string
  cta: string
  href: string
}

function ArticleCard ({ img, title, subtitle, cta, href }: ArticleCardProps) {
  const classes = useStyles();

  return (
    <Grid
      container
      item
      xs={12}
      sm={4}
      alignItems='flex-start'
      direction='row'
      justify='flex-start'
    >
      <Image
        src={img}
        width={368}
        height={207}
        className={classes.img}
        alt=''
      />
      <Typography
        gutterBottom
        variant='h5'
        component='h3'
        className={classnames(classes.title)}
      >
        <Translate content={title} />
      </Typography>
      <Typography
        variant='body2'
        color='textSecondary'
        component='p'
        className={classnames(classes.subtitle)}
      >
        <Translate content={subtitle} />
      </Typography>
      <Button
        href={href}
        size='small'
        color='primary'
        className={classnames(classes.btn)}
      >
        <Translate content={cta} />
      </Button>
    </Grid>
  );
}

export default ArticleCard;
